import styled from "styled-components";

export const Heading6 = styled.h6`
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px; /* 160% */
  letter-spacing: 0.15px;
`;
